import { registerHandler } from '@/utils/queues/pc-queues'

export const registerHandlerElementYoutubeVideo = (): void => {
  registerHandler('element.youtubeVideo', function (...args) {
    import(
      /* webpackChunkName: '@/elements/youtube-video' */ '@/elements/youtube-video'
    ).then(({ init }) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore: Inlined JavaScript is inherently not type checked
      init(...args)
    })
  })
}
